<template>
  <VA class="more-move-to-cart-wrapper" :onClick="backToShop">
    <VBlock class="more-move-to-cart">
      <VBlock class="text-layer">
        <VBlock class="plus-icon-wrapper" :direction="Direction.row" :sort="Sort.center_center">
          <VImage :type="ImageType.img" :src="resources.plusIcon" :width="24" :height="24" />
        </VBlock>
        <VSpan text="더 담으러 가기" :size="14" :color="TextColor.brand" :weight="TextWeight.bold" />
      </VBlock>
      <VSpeechBubble v-show="showTooltip" class="speech-bubble-wrapper">
        <VSpan
          class="bubble-text"
          :text="`${aLittleLongerAmount}원 더 담으면 즉시할인 ${discountAmount}원`"
          :color="TextColor.white"
          :size="15"
          :weight="TextWeight.bold"
          :type="TextType.Number"
        />
      </VSpeechBubble>
    </VBlock>
  </VA>
</template>

<script>
import VSpan, {
  TextColor,
  TextWeight,
  TextType
} from '@/presentationals/v2/components/layouts/atoms/VSpan'
import VImage, { ImageType } from '@/presentationals/v2/components/layouts/atoms/VImage'

import VA from '@/presentationals/v2/components/layouts/molecules/VA'
import VBlock, { Direction, Sort } from '@/presentationals/v2/components/layouts/molecules/VBlock'
import VSpeechBubble from '@/presentationals/v2/components/layouts/molecules/VSpeechBubble'

import VButton from '@/presentationals/v2/components/layouts/atoms/VButton'

import plusIcon from '@/assets/images/plus-mint-nor-24.svg'

export default {
  name: 'MoreMoveToCart',
  props: {
    backToShop: {
      type: Function,
      required: true
    },
    discountAmount: {
      type: Number,
      required: true
    },
    aLittleLongerAmount: {
      type: Number,
      required: true
    },
    isProvideImmediateDiscount: {
      type: Boolean,
      required: false
    }
  },
  computed: {
    showTooltip() {
      return this.isProvideImmediateDiscount && this.aLittleLongerAmount !== 0
    }
  },
  components: {
    VSpan,
    VImage,
    VButton,

    VA,
    VBlock,
    VSpeechBubble
  },
  data() {
    return {
      Direction,
      Sort,
      ImageType,
      TextColor,
      TextWeight,
      TextType,

      resources: {
        plusIcon
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.more-move-to-cart-wrapper {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;

  .more-move-to-cart {
    position: relative;
    width: 100%;
    height: auto;
    top: 0;
    left: 0;
    box-sizing: border-box;
    padding: 12px;
    background-color: $background-white;
    margin-bottom: 10px;
    border-top: 1px solid $light-gray-8;
    border-bottom: 1px solid $light-gray-5;

    .text-layer {
      height: 24px;

      .plus-icon-wrapper {
        width: 24px;
        height: 24px;
      }
    }

    .speech-bubble-wrapper {
      width: 100%;
      top: 44px;

      .bubble-text {
        // position: relative;
        // padding-top: 5px;
      }
    }
  }
}
</style>
